





















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import dynamicLoadSelect from "./dynamicLoadSelect.vue";
import dynamicLoadSelectTree from "./dynamicLoadSelectTree.vue";

const product = namespace("product");
@Component({
  components: { dynamicLoadSelect, dynamicLoadSelectTree }
})
export default class search extends Vue {
  input1: string = "";
  @product.State params;
  @product.State PageInput;
  @product.Action getPorducts;
  @product.Mutation setPageInput;
  @product.Mutation setParams;

  searchForm: any = {
    productName: "",
    productCode: "",
    productNo: "",
    brandCode: [],
    categoryCode: [],
    onboardTime: [],
    createTime: [],
    status: "",
    barcode: "",
    channelSkuCode: ""
  };
  showMore = false;
  get statusList() {
    return [
      {
        label: this.$t("Basic.Active"),
        value: 1
      },
      {
        label: this.$t("Basic.Inactive"),
        value: 0
      }
    ];
  }
  created() {}
  async handleSearch(): Promise<void> {
    this.setParams({ ...this.searchForm });
    this.setPageInput({
      ...this.PageInput,
      pageNum: 1
    });
    let { searchParams } = await this.getPorducts();
    this.$emit("search", searchParams);
  }
  handleReset() {
    (this.$refs.searchForm as any).resetFields();
    this.searchForm.brandCode = [];
    this.searchForm.categoryCode = [];
    this.handleSearch();
  }
  selectBrand(data) {
    let result: any = [];
    if (data && data.length > 0) {
      result = data.map(_ => _.value);
    }
    this.searchForm.brandCode = result;
  }
  selectCategory(data) {
    this.searchForm.categoryCode = [...data];
  }
  handleMore() {
    this.showMore = !this.showMore;
  }
  beforeDestroy() {
    (this.$refs.searchForm as any).resetFields();
    this.searchForm.brandCode = [];
    this.searchForm.categoryCode = [];
    this.setParams({ ...this.searchForm });
  }
  createProduct() {
    (this.$refs.selectFamilyDialog as any).visible = true;
  }
}
